<template>
    <a-drawer
      title="评价指标及内涵"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="30%">
        <a-list item-layout="horizontal" :data-source="rules">
            <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta
                    :description="item.text"
                >
                    <p slot="title">{{ item.title }}</p>
                </a-list-item-meta>
            </a-list-item>
        </a-list>
        <div class="btn-box">
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>

</template>

<script>
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                rules:[
                        {
                            title: '教学理念',
                            text:'坚持立德树人要求，教学观点正确，突出课堂德育；治学严谨，言论健康，风格突出，感染力强；符合“学生中心、产出导向和持续改进”的教育教学理念。'
                        },
                        {
                            title: '教学内容',
                            text:'贯彻教学大纲，教学内容充实、渗透专业思想；注重研究型挑战性教学设计，反映学科新思想、新概念、新成果；教学载体能有效支撑课程目标。'
                        },
                        {
                            title: '授课方式',
                            text:'重点突出，条理清晰，内容承前启后，循序渐进；讲解熟练，有深度、有广度；注重师生互动和启发思维教学模式，重视培养学生分析和解决问题能力。'
                        },
                        {
                            title: '教学手段',
                            text:'教学过程安排合理，方法运用灵活、恰当；启发性强，能有效调动学生思维和学习积极性；熟练、有效地运用现代信息技术；板书工整、结构合理。'
                        },
                        {
                            title: '课堂氛围',
                            text:'课内互动自然、实施方式多样化，教师关注学生学习成果、课堂应变能力强；讲课有激情、能吸引学生注意力，学生深度参与课堂互动、课堂气氛融洽。'
                        },
                        {
                            title: '形象举止',
                            text:'教态仪表自然得体，精神饱满，亲和力强；语言清晰、流畅、准确、生动，语速节奏恰当；为人师表，严于律己，不迟到早退。'
                        },
                        {
                            title: '过程管理',
                            text:'课前准备充分，课前、课后有指导；对学生的自主学习提供必要的支持和指导，全面训练学生知识、能力与素质；规范学生出勤，课堂教学秩序管理严格。'
                        },
                        {
                            title: '教学效果',
                            text:'课堂讲授富有吸引力，教学进度安排合理；关注学生创新能力培养，有效激发学生学习兴趣；教学模式新颖，有利于课程目标达成，教学效果好。'
                        }
                    ]

            }
        },
        mounted () {
        },
        methods:{
            showDrawer(name,id){
                this.id=id;
                this.actionName=name;
                this.visible=true;
            },
            onClose() {
               this.visible = false;
                this.$parent.fetch()
            }
        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 8rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 8rem);
    }
    .input-box .tips{
        width: calc(100% - 8rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

    .ant-list-item-meta {
        display: flex;
        flex: 1;
        align-items: flex-start;
        font-size: 1rem;
    }

</style>
